export default __webpack_public_path__ + "static/media/ms_customers_icon.bdd39127.svg";